import { loadQuery } from 'react-relay';
import { getUserId } from 'lib/utils/authentication';
import { EVENTS_QUERY } from 'services/event/event.relay.services';
import { eventsQuery } from 'services/event/__generated__/eventsQuery.graphql';
import RelayEnvironment from 'lib/utils/relay';

// This is one week before the date where payments were first captured in
// the payments table. We want to retrieve all sessions that exist after
// this date and not before.
const earliestDateToFetchFrom = new Date('2024-07-01');

export const SessionsPreloadData = () => {
  const userId = getUserId() ?? '';

  return {
    eventsQueryRef: loadQuery<eventsQuery>(
      RelayEnvironment,
      EVENTS_QUERY,
      {
        first: 500,
        filter: {
          where: {
            userId: { equalTo: userId },
            beginsAt: { moreThanOrEqualTo: earliestDateToFetchFrom.toISOString() },
            deletedAt: { isNull: true },
            practitionerConfirmationDatetime: {
              notNull: true,
            },
            eventGuests: {
              salesOrders: {
                type: {
                  equalTo: 'unmind_session',
                },
              },
            },
          },
        },
        ordering: [{ sort: 'BEGINS_AT', direction: 'DESC' }],
        skip: !userId,
      },
      { fetchPolicy: 'store-or-network' },
    ),
  };
};
